import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_TYPE_GET_LIST } from 'api/utilityActionTypes';

export default async function getUtilityTypeListAction(
  { state, utilityApiClient },
  { refresh } = {},
) {
  typeCheck('refresh::Maybe Boolean', refresh);
  const utilityTypeListStatePath = ['utilityTypes', 'list'];
  if (!refresh && state.get(utilityTypeListStatePath)) {
    return state.get(utilityTypeListStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_TYPE_GET_LIST,
    state: state,
    onSuccess(utilityProviderList) {
      state.set(utilityTypeListStatePath, utilityProviderList);
    },
  });
}
